import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useAssets } from "../context/AssetContext";
import BulkCreateModal from "./BulkCreateModal";
import "../styles/AssetList.css";

const AssetList = () => {
  const { assets, loading, error, pagination, fetchAssets } = useAssets();
  const [filters, setFilters] = useState({
    assetCode: "",
    name: "",
    status: "",
    limit: 10,
    offset: 0,
  });
  const [showBulkModal, setShowBulkModal] = useState(false);
  useEffect(() => {
    fetchAssets(filters).catch((err) => console.error(err));
  }, [filters, fetchAssets]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value || undefined,
      offset: 0,
    }));
  };

  const changePage = (page) => {
    setFilters((prev) => ({
      ...prev,
      offset: (page - 1) * pagination.limit,
    }));
  };

  if (error) return <div className="error">Error: {error}</div>;

  return (
    <div className="asset-list-container">
      <div className="asset-list-header">
        <h1>Assets</h1>
        <button className="btn btn-primary" onClick={() => setShowBulkModal(true)}>
          + Bulk Create Assets
        </button>

        <Link to="/assets/create" className="btn btn-primary">
          + Create Asset
        </Link>
      </div>

      <BulkCreateModal isOpen={showBulkModal} onClose={() => setShowBulkModal(false)} onSuccess={() => fetchAssets(filters)} />

      <div className="filters">
        <input type="text" name="assetCode" placeholder="Filter by asset code" value={filters.assetCode} onChange={handleFilterChange} />
        <input type="text" name="name" placeholder="Filter by asset name" value={filters.name} onChange={handleFilterChange} />
        <select name="status" value={filters.status} onChange={handleFilterChange}>
          <option value="">All Status</option>
          <option value="available">Available</option>
          <option value="assigned">Assigned</option>
          <option value="maintenance">In Maintenance</option>
          <option value="damaged">Damaged</option>
          <option value="lost">Lost</option>
          <option value="disposed">Disposed</option>
        </select>
      </div>

      {loading && <div className="loading">Loading assets...</div>}

      {assets.length === 0 ? (
        <div className="empty-state">
          <p>No assets found</p>
          <Link to="/assets/create" className="btn btn-primary">
            Create First Asset
          </Link>
        </div>
      ) : (
        <table className="assets-table">
          <thead>
            <tr>
              <th>Asset Tag</th>
              <th>Name</th>
              <th>Type</th>
              <th>Status</th>
              <th>Assigned To</th>
              <th>Location</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {assets.map((asset) => (
              <tr key={asset.id}>
                <td>
                  <Link to={`/assets/${asset.id}`}>{asset.asset_code}</Link>
                </td>
                <td>{asset.name}</td>
                <td>{asset.assetType?.name}</td>
                <td>
                  <span className={`badge badge-${asset.status}`}>{asset.status}</span>
                </td>
                <td>{asset.assignedTo || "-"}</td>
                <td>{asset.location || "-"}</td>
                <td>
                  <Link to={`/assets/${asset.id}/edit`} className="btn btn-sm btn-secondary">
                    Edit
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {pagination.totalPages > 1 && (
        <div className="pagination" aria-label="Asset list pagination">
          <button className="btn btn-secondary" disabled={pagination.page <= 1 || loading} onClick={() => changePage(pagination.page - 1)}>
            Previous
          </button>
          <span>
            Page {pagination.page} of {pagination.totalPages}
          </span>
          <button className="btn btn-secondary" disabled={pagination.page >= pagination.totalPages || loading} onClick={() => changePage(pagination.page + 1)}>
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default AssetList;
